import { BillingStats } from '@/components/ReservationContext'
import { Card, CardContent, CardHeader, CardTitle } from '@/shared/ui/card'

interface BillingStatsCardsProps {
    stats: BillingStats
}

export function BillingStatsCards({ stats }: BillingStatsCardsProps) {
    return (
        <div className='grid grid-cols-4 gap-4'>
            <Card>
                <CardHeader className='pb-2'>
                    <CardTitle className='text-sm font-medium text-muted-foreground'>Total General</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className='text-2xl font-bold'>
                        {stats.totalGeneral.toLocaleString('es-ES', {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 0,
                        })}
                        €
                    </div>
                </CardContent>
            </Card>
            <Card className='border-l-4' style={{ borderLeftColor: '#4B6BFB' }}>
                <CardHeader className='pb-2'>
                    <CardTitle className='text-sm font-medium text-muted-foreground'>Hotel</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className='text-2xl font-bold' style={{ color: '#4B6BFB' }}>
                        {stats.totalHotel.toLocaleString('es-ES', {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 0,
                        })}
                        €
                    </div>
                </CardContent>
            </Card>
            <Card className='border-l-4' style={{ borderLeftColor: '#10B981' }}>
                <CardHeader className='pb-2'>
                    <CardTitle className='text-sm font-medium text-muted-foreground'>Peluquería</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className='text-2xl font-bold' style={{ color: '#10B981' }}>
                        {stats.totalPeluqueria.toLocaleString('es-ES', {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 0,
                        })}
                        €
                    </div>
                </CardContent>
            </Card>
            <Card className='border-l-4' style={{ borderLeftColor: '#F59E0B' }}>
                <CardHeader className='pb-2'>
                    <CardTitle className='text-sm font-medium text-muted-foreground'>Tienda</CardTitle>
                </CardHeader>
                <CardContent>
                    <div className='text-2xl font-bold' style={{ color: '#F59E0B' }}>
                        {stats.totalTienda.toLocaleString('es-ES', {
                            maximumFractionDigits: 2,
                            minimumFractionDigits: 0,
                        })}
                        €
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}
